/*
 * @Author: your name
 * @Date: 2021-03-19 14:44:12
 * @LastEditTime: 2022-03-03 14:56:37
 * @LastEditors: zhaozhuo
 * @Description: In User Settings Edit
 * @FilePath: \edc-mobile-web\src\register\index.js
 */
import Vue from 'vue'
import {
	Button,
	Dialog,
	Form,
	Field,
	Cell,
	CellGroup,
	Picker,
	Popup,
	DatetimePicker,
	Radio,
	RadioGroup,
	Icon,
	Checkbox,
	CheckboxGroup,
	Toast,
	Uploader,
	Collapse,
	CollapseItem,
	Cascader,
	Overlay,
	Loading,
	Divider,
	ImagePreview,
	Image,
	Tab,
	Tabs,
	Popover,
	Badge,
	Empty,
	Swipe,
	SwipeItem,
	Tabbar,
	TabbarItem,
	Calendar,
	List,
	SwipeCell,
	NoticeBar,
	ActionSheet
} from 'vant'
import DhcRegionPicker from '@/utilsComponents/regionPicker'
import DhcTimePicker from '@/utilsComponents/timePicker'
import DhcYearPicker from '@/utilsComponents/yearPicker'
import DhcSelectPicker from '@/utilsComponents/selectPicker'
import DhcYearMonthPicker from '@/utilsComponents/yearMonthPicker'
import DhcDatePicker from '@/utilsComponents/datePicker'
import DhcDateTimePicker from '@/utilsComponents/dateTimePicker'
import DhcFieldInput from '@/utilsComponents/fieldInput'
import DhcFileUpload from '@/utilsComponents/fileUpload'
import DhcDialog from '@/utilsComponents/dialog'
import VueScroll from 'vue-scroll-mobile'
Vue.component('DhcRegionPicker', DhcRegionPicker)
Vue.component('DhcTimePicker', DhcTimePicker)
Vue.component('DhcYearPicker', DhcYearPicker)
Vue.component('DhcSelectPicker', DhcSelectPicker)
Vue.component('DhcYearMonthPicker', DhcYearMonthPicker)
Vue.component('DhcDatePicker', DhcDatePicker)
Vue.component('DhcDateTimePicker', DhcDateTimePicker)
Vue.component('DhcFieldInput', DhcFieldInput)
Vue.component('DhcFileUpload', DhcFileUpload)
Vue.component('DhcDialog', DhcDialog)
Vue.use(VueScroll)
Vue.use(Button)
Vue.use(Dialog)
Vue.use(Form)
Vue.use(Field)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Picker)
Vue.use(Popup)
Vue.use(DatetimePicker)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Icon)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Toast)
Vue.use(Uploader)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Cascader)
Vue.use(Overlay)
Vue.use(Loading)
Vue.use(Divider)
Vue.use(ImagePreview)
Vue.use(Image)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Popover)
Vue.use(Badge)
Vue.use(Empty)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Calendar)
Vue.use(List)
Vue.use(SwipeCell)
Vue.use(NoticeBar)
Vue.use(ActionSheet)